'use client'

import React from 'react'
import { ctaRenderers } from './ctaRenderers'
import styles from './styles.module.scss'

interface CommsModalContentProps {
  isMobile: boolean
  content: any
}

const ModalContent: React.FC<CommsModalContentProps> = ({ isMobile, content }) => (
  <div className={styles.modalContent}>
    <h2 className={styles.modalTitle}>{content?.title}</h2>
    {content?.subtitle !== 'empty' && <p className={styles.modalSubtitle}>{content?.subtitle}</p>}
    <div className={styles.modalCards}>
      {content?.commsCtas?.map((cta: any, idx: number) => {
        const isHalfWidth = idx < 2
        const renderCTA = ctaRenderers[cta.Type]
        if (!renderCTA) return null

        return (
          <div
            key={idx}
            className={`${styles.modalCard} ${
              isHalfWidth && cta.Type === 'Email' ? styles.halfWidthCard : styles.fullWidthCard
            }`}>
            {renderCTA(cta, isMobile, isHalfWidth)}
          </div>
        )
      })}
    </div>
  </div>
)

export default ModalContent
